"use client";

import React, { useState } from "react";
import styles from "./DynamicTable.module.scss";
import Link from "@components/atoms/Link";

export interface TableColumn {
  key: string;
  label: string;
  hasHref?: boolean;
  align?: 'left' | 'center' | 'right';
}

export interface TableRow {
  [key: string]: React.ReactNode;
}

interface CleanTableProps {
  data: TableRow[];
  columns: TableColumn[];
  className?: string;
  initialVisibleRows?: number;
}

export default function DynamicTable({
  data,
  columns,
  className = "",
  initialVisibleRows,
}: CleanTableProps) {
  const [showAll, setShowAll] = useState(false);
  const hasRowLimit =
    initialVisibleRows !== undefined && initialVisibleRows > 0;
  const visibleData =
    hasRowLimit && !showAll ? data.slice(0, initialVisibleRows) : data;
  const hasMoreRows = hasRowLimit && data.length > initialVisibleRows;

  return (
    <div className={`${styles["clean-table-wrapper"]} ${className}`}>
      <div className={styles['table-container']}>
        <table className={styles['styled-table']}>
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} style={{ textAlign: col.align || 'left' }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibleData.map((row: any, rIdx: any) => (
              <tr key={rIdx}>
                {columns.map((col, cIdx) => (
                  <td key={cIdx} style={{ textAlign: col.align || 'left' }}>
                    {col.hasHref && row.href ? (
                      <Link href={row.href}>{row[col.key]}</Link>
                    ) : (
                      row[col.key]
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {hasMoreRows && (
        <button
          type="button"
          className={styles.showMoreButton}
          onClick={() => setShowAll((isShowingAll) => !isShowingAll)}
        >
          {showAll ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};
